import ViewModelBase from './ViewModelBase';
import enableAcceptBindings from '../mvvm/enableAcceptBindings';
import exposeBinding from '../mvvm/exposeBinding';
export default class UnitViewModel extends ViewModelBase{
	constructor(props){
		super(props);
		const {siteJsonUnit}=props;
		this._siteJsonUnit = siteJsonUnit;
		enableAcceptBindings(this);
		//exposeBinding(this, 'position', ()=>siteJsonPlotsPlot.position, (value)=>siteJsonPlotsPlot.position = value);
	}
	get location(){
		return this._siteJsonUnit.location;
	}
	get code(){
		return this._siteJsonUnit.code;
	}
}